import { privateApi } from '../ApiService';
import { SsoConnection, SsoConnectionAdd, SsoConnections } from './types';

const fetchSsoConnectionsList = async (businessAccountId: string): Promise<SsoConnections> =>
    privateApi.get<SsoConnections>(`business-accounts/${businessAccountId}/sso-connections`);

const addSsoConnection = async (businessAccountId: string, payload: SsoConnectionAdd): Promise<SsoConnection> =>
    privateApi.post<SsoConnection>(`business-accounts/${businessAccountId}/sso-connections`, payload);

export const SsoConnectionsGateway = {
    fetchSsoConnectionsList,
    addSsoConnection,
};
